import withStyles from "@material-ui/core/styles/withStyles";
import { useTheme } from "@mui/material/styles";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import Card from "../../material-dashboard/components/Card/Card.jsx";
import CardBody from "../../material-dashboard/components/Card/CardBody.jsx";
import GridContainer from "../../material-dashboard/components/Grid/GridContainer.jsx";

import consultationStyles from "../styles/consultationStyles.js";

import { COLOR_KICK_BLUE } from "~/shared/sharedConstants.js";

import PersonaVerificationDialog from "~/shared/widgets/PersonaVerificationDialog.jsx";

const PhotoVerification = (props) => {
  const { classes } = props;

  const theme = useTheme();
  const fullScreenPersonaDialog = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div
      //   className={classes.container}
      style={{ backgroundColor: COLOR_KICK_BLUE }}
    >
      <GridContainer justifyContent="center">
        <Card className={classes.cardConsultation}>
          <CardBody
            className={classes.paymentCardBody}
            style={{
              //   height: "1200px",
              border: "5px solid red",
              justifyContent: "center",
            }}
          >
            {/* <GridItem xs={12} sm={12} md={12} lg={12}> */}
            {/* {PersonaInlineInquiry(fullScreen, classes)} */}
            {/* </GridItem> */}
            <PersonaVerificationDialog
              fullScreen={fullScreenPersonaDialog}
              userID="3fc94094-70d9-458a-a457-4b0a446d8118"
              email="justin@gokick.com"
              phoneNumber="555-1234"
              visitID="75c1d2eb-3d58-473f-9c64-ea045adfd716"
              onComplete={({ inquiryId, status, fields }) => {
                console.log("onComplete parent called");
              }}
            />
          </CardBody>
        </Card>
      </GridContainer>
    </div>
  );
};

export default withStyles(consultationStyles)(PhotoVerification);
